/* tslint:disable */
/* eslint-disable */
/**
 * Web App core API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { Currency } from './Currency';
import {
    CurrencyFromJSON,
    CurrencyFromJSONTyped,
    CurrencyToJSON,
} from './Currency';

/**
 * 
 * @export
 * @interface UsageGrouped
 */
export interface UsageGrouped {
    /**
     * group by attribute values (ex. for group=organization,laundry)
     * @type {string}
     * @memberof UsageGrouped
     */
    groupLabel: string;
    /**
     * 
     * @type {number}
     * @memberof UsageGrouped
     */
    count: number;
    /**
     * 
     * @type {number}
     * @memberof UsageGrouped
     */
    sumAmount: number;
    /**
     * 
     * @type {number}
     * @memberof UsageGrouped
     */
    avgAmount: number;
    /**
     * 
     * @type {number}
     * @memberof UsageGrouped
     */
    minAmount: number;
    /**
     * 
     * @type {number}
     * @memberof UsageGrouped
     */
    maxAmount: number;
    /**
     * 
     * @type {Currency}
     * @memberof UsageGrouped
     */
    currency: Currency;
}

/**
 * Check if a given object implements the UsageGrouped interface.
 */
export function instanceOfUsageGrouped(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "groupLabel" in value;
    isInstance = isInstance && "count" in value;
    isInstance = isInstance && "sumAmount" in value;
    isInstance = isInstance && "avgAmount" in value;
    isInstance = isInstance && "minAmount" in value;
    isInstance = isInstance && "maxAmount" in value;
    isInstance = isInstance && "currency" in value;

    return isInstance;
}

export function UsageGroupedFromJSON(json: any): UsageGrouped {
    return UsageGroupedFromJSONTyped(json, false);
}

export function UsageGroupedFromJSONTyped(json: any, ignoreDiscriminator: boolean): UsageGrouped {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'groupLabel': json['groupLabel'],
        'count': json['count'],
        'sumAmount': json['sumAmount'],
        'avgAmount': json['avgAmount'],
        'minAmount': json['minAmount'],
        'maxAmount': json['maxAmount'],
        'currency': CurrencyFromJSON(json['currency']),
    };
}

export function UsageGroupedToJSON(value?: UsageGrouped | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'groupLabel': value.groupLabel,
        'count': value.count,
        'sumAmount': value.sumAmount,
        'avgAmount': value.avgAmount,
        'minAmount': value.minAmount,
        'maxAmount': value.maxAmount,
        'currency': CurrencyToJSON(value.currency),
    };
}

